/**
 * *****************
 * BOX TEXT HEIGHT
 * *****************
 */

/**
 * Dom load event
 */
document.addEventListener('DOMContentLoaded', function() {
    setHeightBoxText();
});

/**
 * Resise event
 */
window.addEventListener('resize', function(event){
    setHeightBoxText();
});

/**
 * Function set the height equal to the width
 */
function setHeightBoxText() {

    /**
     * Variable
     * @type {NodeList}
     */
    var boxText = document.getElementsByClassName('box-text');
    var boxTextInner = document.getElementsByClassName('box-text__inner');

    /**
     * Set the height equal to the width
     */
    for(var i = 0; i < boxText.length; i++) {
        boxText[i].style.minHeight = boxText[i].offsetWidth + 'px';
        boxTextInner[i].style.minHeight = boxTextInner[i].offsetWidth + 'px';
    }
}